module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-container"
  }, [(_vm.view === 'portrait') ? _c('div', {
    key: _vm.view
  }, [_c('div', {
    staticClass: "info-wrapper"
  }, [_c('div', {
    staticClass: "info-head"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('h3', {
    key: _vm.selectedCountry.ID,
    class: 'flag-' + _vm.selectedCountry.ID
  }, [_vm._v(_vm._s(_vm.selectedCountry.Land))])]), _vm._v(" "), _c('p', {
    staticClass: "icon-eu"
  }, [_vm._v("Beitrittsjahr: \n            "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('span', {
    key: _vm.selectedCountry.ID
  }, [_vm._v(_vm._s(_vm.getYear()))])])], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-population"
  }, [_vm._v("Einwohner 2025: "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('span', {
    key: _vm.selectedCountry.ID
  }, [_vm._v(_vm._s(_vm.getPopulation()) + " Mio.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "info-body"
  }, [_c('ul', {
    staticClass: "info-list"
  }, _vm._l((_vm.filter), function(item, index) {
    return (item.value !== '8') ? _c('li', {
      key: item.value,
      class: item.cl
    }, [_c('div', [_vm._v("\n                " + _vm._s(_vm.getLabel(item.value, _vm.selectedCountry)) + "\n                "), _c('span', [_vm._v(_vm._s(_vm.getDescription(item.value, _vm.selectedCountry)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-value"
    }, [_c('transition', {
      attrs: {
        "name": "fade",
        "mode": "out-in"
      }
    }, [_c('span', {
      key: _vm.selectedCountry.ID
    }, [_vm._v(_vm._s(_vm.getValue(item.value, _vm.selectedCountry)) + " " + _vm._s(item.unit))])])], 1)]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.view === 'comparison') ? _c('div', {
    key: _vm.view
  }, [_c('div', {
    staticClass: "info-wrapper-height"
  }, [(_vm.curFilter && _vm.countries.length > 0) ? _c('div', {
    staticClass: "info-wrapper"
  }, [_c('div', {
    staticClass: "info-head filter"
  }, [_c('div', {
    class: _vm.curFilter.cl
  }, [_c('h3', [_vm._v(_vm._s(_vm.getLabel(_vm.curFilter.value, _vm.countries[0])))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getDescription(_vm.curFilter.value, _vm.countries[0])))])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('ul', {
    staticClass: "chart"
  }, [_vm._l((_vm.sortCountries(_vm.curFilter.value, _vm.countries)), function(item, index) {
    return (item.Euro === '1') ? _c('li', {
      key: item.ID
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.Land))]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('div', {
      staticClass: "bar",
      staticStyle: {
        "width": "0%, margin-left:0"
      },
      attrs: {
        "aniWidth": _vm.getBarWidth(item, _vm.curFilter)
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.getValue(_vm.curFilter.value, item)) + " " + _vm._s(_vm.curFilter.unit))])])]) : _vm._e()
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "label"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar-wrapper"
  }, [_c('div', {
    staticClass: "bar z",
    attrs: {
      "aniWidth": _vm.getBarWidth(null, _vm.curFilter)
    }
  }, [_c('div', {
    staticClass: "zero"
  })])])])], 2)])]) : _c('div', {
    staticClass: "info-wrapper preview"
  }, [_c('div', {
    staticClass: "info-head filter"
  }, [_c('div', {
    class: _vm.filter[0].cl
  }, [_c('h3', [_vm._v(_vm._s(_vm.getLabel(_vm.filter[0].value, _vm.all[0])))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getDescription(_vm.filter[0].value, _vm.all[0])))])])]), _vm._v(" "), _c('ul', {
    staticClass: "chart"
  }, [_vm._l((_vm.sortCountries(_vm.filter[0].value, _vm.all)), function(item, index) {
    return (item.Euro === '1' && index < 4) ? _c('li', {
      key: item.ID
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.Land))]), _vm._v(" "), _c('div', {
      staticClass: "bar-wrapper"
    }, [_c('div', {
      staticClass: "bar",
      staticStyle: {
        "width": "0%"
      },
      attrs: {
        "aniWidth": _vm.getBarWidth(item, _vm.filter[0])
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.getValue(_vm.filter[0].value, item)) + " " + _vm._s(_vm.filter[0].unit))])])]) : _vm._e()
  }), _c('li', [_c('div', {
    staticClass: "label"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar-wrapper"
  }, [_c('div', {
    staticClass: "bar",
    attrs: {
      "aniWidth": _vm.getBarWidth(null, _vm.curFilter)
    }
  }, [_c('div', {
    staticClass: "zero"
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "info-messages"
  }, [(!_vm.curFilter) ? _c('p', [_vm._v("Wählen Sie eine Kennzahl aus.")]) : _vm._e(), _vm._v(" "), (_vm.countries.length === 0) ? _c('p', [_vm._v("Wählen Sie die Länder zum Vergleich aus.")]) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-749a4e36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/Info.vue
// module id = 570
// module chunks = 0